import { render, staticRenderFns } from "./macro-navigation-section.vue?vue&type=template&id=e90bffe4&scoped=true&"
import script from "./macro-navigation-section.vue?vue&type=script&lang=js&"
export * from "./macro-navigation-section.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./style.scss?vue&type=style&index=0&id=e90bffe4&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e90bffe4",
  null
  ,true
)

export default component.exports